import _ from 'underscore';
const {Backbone} = require('backboneAdapter');
import ThisModel from 'js/models/component.model';

    export default Backbone.Collection.extend({
        model: ThisModel,
        initialize: function () {
            var self = this;
            self.on('sync', function () {
                self.each(function (comp) {
                    comp.changed = {};
                });
            });
        }
    });
